// extracted by mini-css-extract-plugin
export default {"select-activity":"selectCertificates_select-activity__AgdzG"};